import * as THREE from 'three'
import * as Utils from './Utils'
import { Listener } from './Listener'
class CameraPointImage {
  constructor (idx, textureMgr, queue) {
    /**
     * @type 点位贴图id，与点位id相同
     */
    this.idx = idx
    this.image512 = new Array(6)
    this.image1K = new Array(6).fill(null).map(() => new Array(4))// 立方体每个面4张照片的中心
    this.image2K = new Array(6).fill(null).map(() => new Array(16))// 立方体每个面16张照片的中心

    this.ready512 = false
    this.loading512 = false

    this._loadedListener = new Listener()

    this.mgr = textureMgr
    this.queue = queue
  }

  /**
   * 创建贴图canvas
   * @param {number} width 宽度
   * @returns {HTMLCanvasElement} 创建后的canvas
   */
  creatTextureCanvas (width) {
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = width
    return canvas
  }

  addLoadedPromiseCallback (resolve, reject) {
    this._loadedListener.add((isSucceed, rls) => {
      if (isSucceed) {
        resolve(rls)
      } else {
        reject(rls)
      }
    })
  }

  /**
   * 加载512贴图
   */
  async load512 (isForce = false) {
    const self = this
    if (this.ready512) {
      return self
    }

    const registAfterLoadFunc = (resolve, reject) => {
      this.addLoadedPromiseCallback(resolve, reject)
    }

    // 如果正在加载，则注册加载完毕事件。
    if (this.loading512) {
      return new Promise(registAfterLoadFunc)
    }

    if (!this.loading512) {
      return this.load512Async(isForce)
    }

    if (this.loading512 && isForce) {
      if (isForce) {
        this.queue.force(this.idx)
      }

      return new Promise(registAfterLoadFunc)
    }
  }

  async load512Async (isForce) {
    let loadCounter = 0
    let scCounter = 0
    const unload = []

    const self = this
    self.loading512 = true

    return new Promise(function (resolve, reject) {
      for (let i = 0; i < 6; ++i) {
        if (self.image512[i] !== undefined) {
          loadCounter++
          scCounter++
        } else {
          self.image512[i] = null
          let p = null
          if (isForce) {
            p = self.loadImageTarget('512', self.idx, i, 0, 0)
          } else {
            p = self.loadImage('512', self.idx, i, 0, 0)
          }

          p
            .then(img => {
              // 加载成功
              self.image512[i] = img
              loadCounter++
              scCounter++

              if (loadCounter === 6) {
                resolve()
              }
            },
            reason => {
              // 加载失败处理
              self.image512[i] = undefined

              reason.unloadIdx = i
              unload.push(reason)

              loadCounter++
              if (loadCounter === 6) {
                resolve()
              }
            })
        }
      }
    }).then(() => {
      // 处理加载情况，处理加载失败情况
      return new Promise(function (resolve, reject) {
        self.addLoadedPromiseCallback(resolve, reject)
        self.loading512 = false
        if (scCounter === 6) {
          self.ready512 = true
          self._loadedListener.invoke(true, self)
        } else {
          self._loadedListener.invoke(false, unload)
        }
      })
    })
  }

  /**
   * 加载1k贴图
   */
  async load1k (face, idxI, idxJ) {
    return this.loadSingleImg(face, idxI, idxJ, '1k', this.image1K, this.ijTo1kIdx)
  }

  /**
   * 加载2k贴图
   */
  async load2k (face, idxI, idxJ) {
    return this.loadSingleImg(face, idxI, idxJ, '2k', this.image2K, this.ijTo2kIdx)
  }

  async loadSingleImg (face, idxI, idxJ, imgQuality, imgArray, indexFunc) {
    const self = this
    if (imgArray[face][indexFunc(idxI, idxJ)] !== undefined) {
      return imgArray[face][indexFunc(idxI, idxJ)]
    }
    imgArray[face][indexFunc(idxI, idxJ)] = null

    return new Promise(function (resolve, reject) {
      self.loadImage(imgQuality, self.idx, face, idxI, idxJ)
        .then(img => {
          if (img === null) {
            resolve(null)
          } else {
            imgArray[face][indexFunc(idxI, idxJ)] = img
            resolve(img)
          }
        },
        reason => {
          imgArray[face][indexFunc(idxI, idxJ)] = undefined
          console.error(`加载${imgQuality}贴图失败`)
          reject(reason)
        })
    })
  }

  /**
   * 1k贴图i和j转换为存储用的数组下标
   * @param {number} idxI 贴图i
   * @param {nubmer} idxJ 贴图j
   */
  ijTo1kIdx (idxI, idxJ) {
    return idxI + idxJ * 2
  }

  /**
   * 2k贴图i和j转换为存储用的数组下标
   * @param {number} idxI 贴图i
   * @param {nubmer} idxJ 贴图j
   */
  ijTo2kIdx (idxI, idxJ) {
    return idxI + idxJ * 4
  }

  drawImage (img, canvas, imgI, imgJ, imgW) {
    const context = canvas.getContext('2d')
    context.drawImage(img, imgI * imgW, imgJ * imgW, imgW, imgW)
  }

  async loadImage (quality, location, faceIdx, imgI, imgJ) {
    switch (quality) {
      case '512':
        return this.queue.load512(this.idx, this.mgr.getTexturePath(location, quality, faceIdx, imgI, imgJ))
      case '1k':
        return this.queue.load1k(this.idx, this.mgr.getTexturePath(location, quality, faceIdx, imgI, imgJ))
      case '2k':
        return this.queue.load2k(this.idx, this.mgr.getTexturePath(location, quality, faceIdx, imgI, imgJ))
    }
    // return new THREE.ImageLoader().loadAsync(this.mgr.getTexturePath(location, quality, faceIdx, imgI, imgJ))
  }

  async loadImageTarget (quality, location, faceIdx, imgI, imgJ) {
    return this.queue.loadTarget(this.idx, this.mgr.getTexturePath(location, quality, faceIdx, imgI, imgJ))
    // return new THREE.ImageLoader().loadAsync(this.mgr.getTexturePath(location, quality, faceIdx, imgI, imgJ))
  }
}

class TileImage {
  constructor (idx, url, callback) {
    this.idx = idx
    this.url = url
    this.callbackList = [callback]
  }

  callback (img, rls) {
    for (const item of this.callbackList) {
      item(img, rls)
    }
  }

  async load () {
    await new THREE.ImageLoader().loadAsync(this.url)
      .then(img => {
        this.callback(img, null)
      },
      reason => {
        this.callback(null, reason)
      })
  }

  cancel () {
    this.callback(null, null)
  }
}

export class QueueLoader {
  constructor (qm) {
    this.qm = qm
    this.loading = false
  }

  async autoLoading () {
    if (this.loading) return
    this.loading = true
    let finish = false
    while (!finish) {
      finish = true
      for (const queue of this.qm.order) {
        if (queue.length !== 0) {
          const target = queue[queue.length - 1]
          queue.pop()
          await target.load()

          finish = false
          break
        }
      }
    }
    this.loading = false
  }
}

export class QualityLoaderManager {
  constructor () {
    this.loading = false

    this.targetIdx = undefined

    this.queue512 = []
    this.queue1k = []
    this.queue2k = []

    this.queueTarget512 = []

    this.order = [this.queueTarget512, this.queue1k, this.queue2k, this.queue512]

    this.loader = []

    this.loaderSize = 5
    this.loaderIdx = 0

    for (let i = 0; i < this.loaderSize; i++) {
      this.loader.push(new QueueLoader(this))
    }
  }

  clear1k2k () {
    for (const item of this.queue1k) {
      item.cancel()
    }
    this.queue1k.length = 0

    for (const item of this.queue2k) {
      item.cancel()
    }
    this.queue2k.length = 0
  }

  force (idx) {
    this.clear1k2k()
    while (true) {
      const findIdx = this.queue512.findIndex((v) => { return v.idx === idx })
      if (findIdx === -1) {
        break
      } else {
        const task = this.queue512[findIdx]
        this.queueTarget512.push(task)
        this.queue512.splice(findIdx, 1)
      }
    }
  }

  pushTask (resolve, reject, queue, idx, url) {
    queue.push(new TileImage(idx, url, (img, err) => {
      if (img !== null || err === null) { resolve(img) } else { reject(err) }
    }))
    this.autoLoading()
  }

  async load1k (idx, url) {
    return new Promise((resolve, reject) => {
      this.pushTask(resolve, reject, this.queue1k, idx, url)
    })
  }

  async load2k (idx, url) {
    return new Promise((resolve, reject) => {
      this.pushTask(resolve, reject, this.queue2k, idx, url)
    })
  }

  async load512 (idx, url) {
    return new Promise((resolve, reject) => {
      this.pushTask(resolve, reject, this.queue512, idx, url)
    })
  }

  async loadTarget (idx, url) {
    this.clear1k2k()
    return new Promise((resolve, reject) => {
      this.pushTask(resolve, reject, this.queueTarget512, idx, url)
    })
  }

  async autoLoading () {
    this.loaderIdx = (this.loaderIdx + 1) % this.loaderSize
    await this.loader[this.loaderIdx].autoLoading()
  }
}

export class TextureManager {
  constructor () {
    /**
     * @type {CameraPointImage[]} 点位贴图缓存
     */
    this.pointImages = []

    this.cubeFaceIdxMap = [1, 3, 0, 5, 4, 2]

    this.tempCanvasLow = new Array(6)
    this.tempCanvasHigh = new Array(6)

    this.basePath = ''
    this.locationSizeLen = 1

    this.textureWidth = 2048

    this.needUpdate = false

    this.rotateMat = new THREE.Matrix4()
    this.location = 0

    this.queue = new QualityLoaderManager()
  }

  /**
   * 初始化贴图管理
   * @param {string} base 根路径
   * @param {number} locationsSize 相机点位数量
   */
  init (base, locationsSize) {
    this.basePath = base
    this.locationSizeLen = locationsSize.toString().length
  }

  /**
   * 探测位置方向并预加载目标点位的位置
   * @param {number} centerIdx 当前位置
   * @param {THREE.Vector3} camDir 摄像机方向
   * @param {CameraPoint[]} points 需要探测的点位
   */
  autoLoad512 (centerIdx, camDir, points) {
    const self = this
    // const centerPos = points[centerIdx].position
    let centerPos = new THREE.Vector3()
    for (const p of points) {
      if (p.id === centerIdx) {
        centerPos = p.position
      }
    }
    const cos20 = Math.cos(Math.PI * 1 / 9)
    for (const p of points) {
      // 不可用方位或已加载则不需加载
      if (!p.isAvailable || !!this.pointImages[p.id] || p.id === centerIdx) { continue }

      const vec = p.position.clone().sub(centerPos)
      const dist = vec.length()
      const cosRls = vec.dot(camDir) / dist

      // 如果可视
      if (cosRls > cos20 && dist < 10000) {
        const cpi = new CameraPointImage(p.id, this, this.queue)
        this.pointImages[p.id] = cpi
        cpi.load512().catch(reason => {
          console.error('load 512 failed')
          self.pointImages[p.id] = undefined
          // todo 清理cpi，以防内存爆炸
        }).then(() => { })
      }
    }
  }

  targetLoad512 (idx) {
    if (!this.pointImages[idx]) {
      this.pointImages[idx] = new CameraPointImage(idx, this, this.queue)
    }
    return this.pointImages[idx].load512(true)
  }

  perload512 (idx) {
    if (!this.pointImages[idx]) {
      this.pointImages[idx] = new CameraPointImage(idx, this, this.queue)
    }
    return this.pointImages[idx].load512()
  }

  drawImage (img, canvas, imgI, imgJ, imgW) {
    const context = canvas.getContext('2d')
    context.drawImage(img, imgI * imgW, imgJ * imgW, imgW, imgW)
  }

  getTexturePath (posIdx, imgQuality, faceNumber, imgI, imgJ, extendName = 'jpg') {
    return [
      this.basePath,
      `location_${Utils.perfixInt(posIdx + 1, this.locationSizeLen)}`,
      `${imgQuality}_face${this.cubeFaceIdxMap[faceNumber]}_${imgI || 0}_${imgJ || 0}.${extendName}`
    ].join('/')
  }
}
